module.exports = __webpack_public_path__ + "img/1.4c4f5b5f.png";